<template>
  <div class="recharge">
   <div :class="isShowMe?'orderDetails':'orderDetails hide'">
      <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
      <div class="detailList">
         <div class="dl-top">
          <div class="dl-title fl">充值</div>
          <div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
        </div>
        <div class="main">
          <el-row  align="middle" type="flex" class="mtb30"> 
            <el-col :span="24"><div class="grid-content bg-purple blue" >暂时只支持支付宝充值</div></el-col>
          </el-row>
          <el-row  align="middle" type="flex" class="mtb30"> 
            <el-col :span="4"><div class="grid-content bg-purple" >输入金额：</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple" ><el-input-number  label="金额" v-model="bal" name="bal" size="medium" controls-position="right" :controls="false"></el-input-number></div></el-col>
            <el-col :span="1"><div class="grid-content bg-purple" ></div></el-col>
            <el-col :span="14"><div class="grid-content bg-purple" >元</div></el-col>
          </el-row>
          <el-row  align="middle" type="flex" class="mtb30"> 
            <el-col :span="24"><div class="grid-content bg-purple tips">手续费1%，最低1元</div></el-col>
          </el-row>
         </div>
         <div class="dl-footer">
             <el-row  align="middle"  type="flex" class="mb20"> 
              <el-col :span="20"><div class="grid-content bg-purple"></div></el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple">
                  <el-button type="primary" size="medium" >下一步</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
      </div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'recharge',
  props:["isShow"],
  data () {
    return {
       isShowMe:this.isShow,
       bal:0
    }
  },
  computed:{
    
  },
  methods: {
    closeWindow(){
			this.isShowMe=false;
    }
  },
  watch: {
    isShow(val) {
      this.isShowMe = val;
    },
    isShowMe(val){
      if(val){
        
      }else{
        this.$emit("on-close",val);
      }
    }
  },
  mounted: function () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .detailList-bg{position:fixed;width:100%;height:100%;bottom:0;left:0; background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:99; }
	.detailList{width:600px;height:360px;position: fixed; top:50%; left:50%; margin-left:-300px; margin-top:-180px;  z-index:999; background: #fff; }
	.detailList .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
	.detailList .dl-title{ font-size:20px; color:#444; margin-left:45px;}
	.detailList .dl-close{ margin-right:25px; margin-top:8px;}
	.detailList .dl-close img{ cursor: pointer;}
  .detailList .dl-footer{height:60px; line-height:60px; font-size:16px; color:#444; background: #eee; position:absolute; bottom:0; width:540px; padding:0 30px;}
  .detailList .main{ padding:15px 30px; font-size:18px; color:#444;}
  .mb20{margin-bottom:20px;}
  .recharge .blue{ color:#4885f0;}
  .recharge .mtb30{ margin:30px 0;}
  .recharge .tips{color:#666; font-size:16px;}
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue